import mobileAdjustment from "../GeneralMobileAdjustments";
import utilMobile from "../../../mobile/commons/MobileGeneralFunctions";

class MobileRadioButtonControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control)[0];
        const $el = $(element);
        const $check = $el.find(".checkbox");
        const $label = $el.find("label");
        const $span = $label.find("span");
        const $input = $label.find("input");

        if(utilMobile.isControlInGroup(control)){
            const handlerContainer= document.createElement('div');
            const handler = document.createElement('i');
            handlerContainer.classList.add('mobile-group-handler');
            handler.classList.add('fa', 'pf-drag', 'draggable');
            handlerContainer.style.cssFloat = 'left';
            handlerContainer.style.position = 'relative';
            handlerContainer.style.marginTop = '1px';
            handlerContainer.appendChild(handler);
            element.insertBefore(handlerContainer, element.firstElementChild);
            element.style.width = '100%';
           
            let checkbox = element.lastElementChild;
            checkbox.style.width = '95%';
            checkbox.style.height = '';
            checkbox.style.lineHeight = '';
            checkbox.style.float = "right";

            checkbox.firstElementChild.style.float = 'left';
            checkbox.firstElementChild.style.marginTop = '2px';
         }
         else{
            $check.css({'width':'auto'});
         }
        
         $el.css({'width':'100%','height':'auto', 'text-align':'left'});
         $check.css({'height':'auto', "line-height":""});
         $label.css({'white-space':'unset','padding-left':'20px'});
         $span.css({'text-wrap':'pretty', 'padding-left':'2px'})
         $input.css({'margin-left':'-19px'});
    }
}

const mobileRadioButtonControlView = new MobileRadioButtonControlView();
export default mobileRadioButtonControlView;